import SsoActionTypes from './sso.types';

export const validateUser = () => ({
	type: SsoActionTypes.VALIDATE_USER.PENDING
})